import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Redirect } from 'react-router';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import TagManager from 'react-gtm-module';
import i18n from './i18n';

import App from './App';
import AccountRoutes from './Routes/Account';
import AppPushPageRoutes from './Routes/AppPushPageRoutes'
import CheckoutRoutes from './Routes/CheckoutRoutes';
import CustomerRoutes from './Routes/Customer';
import DealRoutes from './Routes/Deal';
import EPhotobookRoute from './Routes/EPhotobook'
import FaqRoute from './Routes/FaqRoute';
import MainLayout from './Layout/Main';
import BlankLayout from 'split-chunk-loader?lazy!./Layout/Blank';
import PageNotFound from 'split-chunk-loader?lazy!./PageNotFound';
import FakePageNotFound from 'split-chunk-loader?lazy!./FakePageNotFound';
import PreCartUpgradeRoutes from './Routes/PreCartUpgrade';
import ProductCategoryRoutes from './Routes/ProductCategory';
import PromotionGroupRoutes from './Routes/PromotionGroup';
import PromotionTnCRoutes from './Routes/PromotionTnC';
import PromotionsRoutes from './Routes/Promotions';
import reducer from './Reducer';
import SearchRoutes from './Routes/Search';
import StaticRoutes, { WrapperlessRoutes } from './Routes/StaticRoutes';
import TaopixRoutes from './Routes/Taopix';
import { loadState } from './Common/localStorage';
import config from '../config';
import SocialLoginRoutes from './Routes/SocialLoginRoutes';
import ConfigurableProductRoutes from './Routes/ConfigurableProductRoutes';
import VerifyEmailRoute from './Routes/VerifyEmailRoute';
import VoucherActivationRoute from './Routes/VoucherActivationRoutes'
import VoucherExpiredRoute from './Routes/VoucherExpiredRoute';
import HowShopBackWorks from 'split-chunk-loader?lazy!./StaticPage/HowShopBackWorks/Container';
import CarbonFreeStatic from 'split-chunk-loader?lazy!./StaticPage/CarbonFreeContainer'
import FreeShippingTierInfo from 'split-chunk-loader?lazy!./StaticPage/FreeShippingTierInfo/Container';
import PaypalPayLaterInfo from 'split-chunk-loader?lazy!./StaticPage/PaypalPayLaterInfo/Container';
import CreditFaq from 'split-chunk-loader?lazy!./StaticPage/Credit/Container';
import ProductRecommendationRoute from './Routes/ProductRecommendation';
import { getConfigValue } from './Common/Providers/ConfigsApi';
import { lazify } from './Common/Helper';
import EGiftCardRoute from './Routes/EGiftCardRoute';
import './ConfigurableProduct/KidsArtwork';

window.ap = {
  netcoreEnabled: false,
};

getConfigValue('netcore').then(res => {
  window.ap.netcoreEnabled = JSON.parse(res).enabled;
})

const tagManagerArgs = {
  gtmId: config.googleTagManagerId,
  dataLayerName: 'dataLayer',
};

TagManager.initialize(tagManagerArgs);

window.addEventListener("storage", e => {
  if (e.key == 'access_token'
    && e.oldValue != null
    && e.oldValue != e.newValue) {
    window.onbeforeunload = null;
    window.location.reload(true);
  }
});

const initialState = {
  userDetail: loadState('UserDetail') || {},
  langCode: '',
  defaultLangCode: '',
  translations: [],
  backendConfig: {},
  paypalPayLater: [],
  abFeatureConfig: {},
};

const routes = (
  <Route>
    <IndexRoute
      helmet={{
        title: 'Photo Books, Wedding Cards, Travel Albums',
        metaDescription: 'At {storeName}, we\'re all about letting you create beautiful photo books. Here, you can find exquisite handmade photo books that you can easily personalize.'
      }}
      component={App} />
    {VoucherActivationRoute}
    {VoucherExpiredRoute}
    {AccountRoutes}
    {AppPushPageRoutes}
    {CustomerRoutes}
    {PromotionsRoutes}
    {StaticRoutes}
    {CheckoutRoutes}
    {EPhotobookRoute}
    {FaqRoute}
    {WrapperlessRoutes}
    {SearchRoutes}
    {TaopixRoutes}
    {PreCartUpgradeRoutes}
    {PromotionGroupRoutes}
    {DealRoutes}
    {ProductCategoryRoutes}
    {SocialLoginRoutes}
    {ConfigurableProductRoutes}
    {VerifyEmailRoute}
    {ProductRecommendationRoute}
    {EGiftCardRoute}
  </Route>
);

let store = createStore(reducer, initialState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

ReactDOM.render((
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <Router onUpdate={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })} history={browserHistory}>
        <Route path='/404.html' exact={true} noIndex component={lazify(PageNotFound)} />
        <Route label="How ShopBack Works" path="/how-shopback-works" component={lazify(HowShopBackWorks)} />
        <Route label="How ShopBack Works" path="/:id/how-shopback-works" component={lazify(HowShopBackWorks)} />
        <Route label="Free Shipping Tier Info" path="/free-shipping-tier-info" component={lazify(FreeShippingTierInfo)} />
        <Route label="Free Shipping Tier Info" path="/:id/free-shipping-tier-info" component={lazify(FreeShippingTierInfo)} />
        <Route label="Paypal Pay Later Info" path="/paypal-pay-later-info" component={lazify(PaypalPayLaterInfo)} />
        <Route label="Paypal Pay Later Info" path="/:id/paypal-pay-later-info" component={lazify(PaypalPayLaterInfo)} />
        <Route label="Carbon Free" path="/carbon-free" component={lazify(CarbonFreeStatic)} />
        <Route label="Carbon Free" path="/:id/carbon-free" component={lazify(CarbonFreeStatic)} />
        <Route label="Credit FAQ" path="/credit-faq" component={lazify(CreditFaq)} />
        <Route label="Credit FAQ" path="/:id/credit-faq" component={lazify(CreditFaq)} />
        <Route label="Home" path="/" component={MainLayout}>
          {routes}
        </Route>
        <Route label="Home" path="/:id" component={MainLayout}>
          {routes}
        </Route>
        <Route label="Tnc" path="/tnc/" component={lazify(BlankLayout)}>
          {PromotionTnCRoutes}
        </Route>
        <Route path='/:id/*' exact={true} noIndex component={lazify(FakePageNotFound)} />
      </Router>
    </I18nextProvider>
  </Provider>

), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js